// extracted by mini-css-extract-plugin
export default {"defaults":"Skeleton_defaults__Hk3qk"};